import { Trans } from "../utils/i18n";
import Cookies from "js-cookie";
import React from "react";
import {validateVinRegEx} from "../Shared/FormField";
import {addressConfig} from "./components/address";

export const orderEntryConfigUnu = {
    "sizes": {
        "forth": 3,
        "third": 4,
        "half": 6,
        "full": 12
    },
    "heading": <Trans i18nKey="orderEntry.basicData">Basic data</Trans>,
    "defaultValues": {
        "private_or_company": "private",
    },
    "groups": [
        {
            "description": <Trans i18nKey={"orderEntry.description"}>Your device is not behaving as you expect? <a href={"https://b2x.com/"} title={'B2X'} target={'_blank'}>B2X</a> support you from here to provide a solution quickly. Please complete the form below and we will get back to you to resolve the situation.</Trans>,
            "fields": [
                {
                    "size": "full",
                    "component": "requesttypeselect"
                }
            ]
        },
        {
            "heading": <Trans i18nKey="orderEntry.productSelection">Product selection</Trans>,
            "description": <Trans i18nKey="orderEntry.productSelection.description"></Trans>,
            "fields": [
                {
                    "size": "full",
                    "component": "productselect"
                }
            ],
            "conditionFunction": values => !!values.requesttype
        },
        {
            "heading": <Trans i18nKey="orderEntry.orderInformation.heading">Order Information</Trans>,
            // "description": <Trans i18nKey="orderEntry.vin.description">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.</Trans>,
            "fields": [
                {
                    "name": "serialnumber",
                    "label": <Trans i18nKey="orderEntry.serialnumber.label">Serial number</Trans>,
                    "size": "full",
                    "required": true
                }
            ],
            "conditionFunction": values => !!values.requesttype && values.product
        },
        {
            "heading": <Trans i18nKey="orderEntry.addressContact">Address & contact information</Trans>,
            "description": <Trans i18nKey="orderEntry.addressContact.description">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.</Trans>,
            "fields": [
                ...addressConfig,
            ],
            "conditionFunction": values => !!values.requesttype && values.product
        },
        {
            "fields": [
            ],
            "conditionFunction": values => !!values.requesttype
        },
        {
            "heading": <Trans i18nKey="orderEntry.notes.label">Notes</Trans>,
            "description": <Trans i18nKey="orderEntry.notes.description"></Trans>,
            "fields": [
                {
                    "size": "full",
                    "key": "notes",
                    "name": "notes",
                    "label": <Trans i18nKey="queueDetail.notes.label">Notes</Trans>,
                    "multiline": true,
                },
            ],
            "conditionFunction": values => !!values.requesttype && values.product
        },
    ],
    "actions": [
        {
            "fields": [
                {
                    "text": <Trans i18nKey="orderEntry.send">Send</Trans>,
                    "size": "half",
                    "component": "button",
                    "action": "next",
                    "color": "secondary",
                    "conditionFunction": values => !!values.requesttype  && values.product
                }
            ],
        }
    ]
}
